export default __webpack_public_path__ + "static/media/bulk-register.af471228.svg";